// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_style_title__KOcXs"};